var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-selector-container" }, [
    _c(
      "div",
      {
        staticClass:
          "is-size-7 is-flex is-flex-direction-row has-text-weight-semibold mb-1",
      },
      [_vm._v(" " + _vm._s(_vm.label) + " ")]
    ),
    _c("div", { staticClass: "control" }, [
      _c("div", { staticClass: "multi-select-container" }, [
        _c(
          "div",
          {
            staticClass: "multi-select-dropdown",
            class: { "is-active": _vm.isDropdownOpen, disabled: _vm.disabled },
            on: {
              click: [
                _vm.toggleDropdown,
                function ($event) {
                  $event.stopPropagation()
                },
              ],
            },
          },
          [
            _c("div", { staticClass: "multi-select-display" }, [
              _vm.displayValue === ""
                ? _c("span", { staticClass: "placeholder" }, [
                    _vm._v(_vm._s(_vm.placeholder)),
                  ])
                : _c("span", { staticClass: "selected-text" }, [
                    _vm._v(" " + _vm._s(_vm.displayValue) + " "),
                  ]),
            ]),
            _c("div", { staticClass: "dropdown-controls" }, [
              !_vm.isMultiSelect && _vm.displayValue !== "" && !_vm.disabled
                ? _c(
                    "button",
                    {
                      staticClass: "clear-button",
                      attrs: { type: "button", title: "Clear selection" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.clearSelection.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" ✕ ")]
                  )
                : _vm._e(),
              _vm._m(0),
            ]),
          ]
        ),
        _vm.isDropdownOpen
          ? _c(
              "div",
              { key: _vm.dropdownKey, staticClass: "multi-select-options" },
              [
                _vm.showSearch
                  ? _c("div", { staticClass: "multi-select-search" }, [
                      _c(
                        "div",
                        { staticClass: "is-flex is-align-items-center" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchTerm,
                                expression: "searchTerm",
                              },
                            ],
                            staticClass: "input is-small",
                            staticStyle: { flex: "1" },
                            attrs: {
                              type: "text",
                              placeholder: `Search ${_vm.label.toLowerCase()}...`,
                            },
                            domProps: { value: _vm.searchTerm },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.searchTerm = $event.target.value
                              },
                            },
                          }),
                          _vm.isMultiSelect
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-small is-success ml-2",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.selectAllFiltered.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Select All ")]
                              )
                            : _vm._e(),
                          _vm.isMultiSelect
                            ? _c(
                                "button",
                                {
                                  staticClass: "button is-small is-light ml-2",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.clearAll.apply(null, arguments)
                                    },
                                  },
                                },
                                [_vm._v(" Clear All ")]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "multi-select-list" },
                  _vm._l(_vm.filteredOptions, function (option) {
                    return _c(
                      "div",
                      {
                        key: _vm.getOptionKey(option),
                        staticClass: "multi-select-option",
                      },
                      [
                        _c("input", {
                          key: `checkbox-${_vm.getOptionKey(option)}`,
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: _vm.getOptionValue(option),
                            checked: _vm.isOptionSelected(option),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleOptionClick(option)
                            },
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "option-text",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleOptionClick(option)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.getOptionLabel(option)))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm.isMultiSelect && _vm.selectedValue?.length > 0
        ? _c("div", { staticClass: "mt-2" }, [
            _c(
              "div",
              { staticClass: "is-size-7 has-text-weight-semibold mb-1" },
              [_vm._v("Selected " + _vm._s(_vm.label) + ":")]
            ),
            _c("div", { staticClass: "selected-items-container" }, [
              _c(
                "div",
                { staticClass: "tags" },
                _vm._l(_vm.selectedValue, function (item) {
                  return _c(
                    "span",
                    { key: item, staticClass: "tag is-small is-success" },
                    [
                      _vm._v(" " + _vm._s(_vm.getDisplayLabel(item)) + " "),
                      !_vm.disabled
                        ? _c("button", {
                            staticClass: "delete is-small",
                            on: {
                              click: function ($event) {
                                return _vm.removeItem(item)
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-chevron-down" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }